import { call, put, select, takeLatest } from "redux-saga/effects";
import { fetchCompanyBuFinancials } from "../../../services/accIqService";
import { FETCH_COMP_BU_FIN_REQUEST, fetchCompBuFinancialFailure, fetchCompBuFinancialSuccess } from "../actions/companyBuFinancialsActions";


// Worker Saga
function* fetchCompBuFinancialSaga() {
  try {
    const payload = yield select(state=>state?.businessUnitAccDetailsReducer?.payload);
    const {accountId, accountName, bu_unit} = payload;
    const data = yield call(fetchCompanyBuFinancials,accountId, accountName, bu_unit);
    yield put(fetchCompBuFinancialSuccess(data));
  } catch (error) {
    yield put(fetchCompBuFinancialFailure(error.message));
  }
}

// Watcher Saga
export function* watchfetchCompBuFinancial() {
  yield takeLatest(FETCH_COMP_BU_FIN_REQUEST, fetchCompBuFinancialSaga);
}
